// Library import
import {createRoot} from 'react-dom/client';
import {Table, Pagination} from 'react-bootstrap';
import Proptypes from 'prop-types';
import {useEffect, useState} from 'react';

// File Import
import Edit from '~/images/icon/edit.png';
import DeleteBlack from '~/images/icon/delete-black.png';
import ShowIcon from '~/images/icon/eye-on.png';
import HideIcon from '~/images/icon/eye-off.png';

// Components Import
import {UserFormModal, DeleteUserModal, Loading} from '@/components';

const AccountManagement = ({usersData, currentUser}) => {
    const [users, setUsers] = useState(usersData?.data || []);
    const [selectedItem, setSelectedItem] = useState({});
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    useEffect(() => {
        setUsers(usersData?.data);
    }, []);

    return (
        <div className='page-wrapper px-4'>
            {currentUser?.admin === 1 ? (
                <div>
                    <div className='create-btn my-3 d-flex justify-content-end'>
                        <button
                            className='button secondary w-auto'
                            onClick={() => {
                                setShowCreateModal(true);
                                setIsEdit(false);
                            }}>
                            新規登録
                        </button>
                    </div>
                    <div className='list-tabler-wrapper'>
                        {/* Table heading show here */}
                        <Table>
                            <thead>
                            <tr>
                                <th>名前</th>
                                <th>パスワード</th>
                                <th>ID</th>
                                <th>編集</th>
                                <th>削除</th>
                            </tr>
                            </thead>

                            {/* Table list data show here */}
                            <tbody>
                            {users?.map((user, index) => (
                                <tr key={index}>
                                    <td>{user?.name}</td>
                                    <td className='icon-thumb d-flex align-items-center'>
                                        <span className='me-2'>***********</span>
                                    </td>
                                    <td>{user?.email}</td>
                                    <td className='icon-thumb'>
                                        <img
                                            onClick={() => {
                                                setSelectedItem(user);
                                                setShowCreateModal(true);
                                                setIsEdit(true);
                                            }}
                                            src={Edit}
                                            alt='Edit icon'
                                        />
                                    </td>
                                    <td className='icon-thumb'>
                                        {user?.admin === 1 ? (
                                            <img style={{opacity: '0.3', cursor: 'not-allowed'}} src={DeleteBlack}
                                                 alt='Delete icon'/>
                                        ) : (
                                            <img
                                                onClick={() => {
                                                    setSelectedItem(user);
                                                    setShowDeleteModal(true);
                                                }}
                                                src={DeleteBlack}
                                                alt='Delete icon'
                                            />
                                        )}
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>

                        {users?.length === 0 && (
                            <Alert variant='secondary' className='text-center'>
                                No list data found
                            </Alert>
                        )}
                    </div>
                    {/* Pagination area */}
                    {usersData?.total > usersData?.per_page && (
                        <Pagination>
                            <Pagination.First href={usersData?.first_page_url}/>
                            <Pagination.Prev href={usersData?.prev_page_url}/>

                            {usersData?.links.slice(1, -1)?.map((link, idx) => (
                                <Pagination.Item key={idx} href={link?.url} active={link?.active}>
                                    {link?.label}
                                </Pagination.Item>
                            ))}

                            <Pagination.Next href={usersData?.next_page_url}/>
                            <Pagination.Last href={usersData?.last_page_url}/>
                        </Pagination>
                    )}
                    {/* Loading */}
                    {loading && <Loading/>}
                    {/* Create user modal */}
                    {showCreateModal && (
                        <UserFormModal
                            show={showCreateModal}
                            isEdit={isEdit}
                            prevFormData={
                                isEdit && {
                                    id: selectedItem?.id,
                                    email: selectedItem?.email,
                                    name: selectedItem?.name,
                                    admin: currentUser?.admin
                                }
                            }
                            handleClose={() => setShowCreateModal(false)}
                        />
                    )}

                    {/* Delete user modal */}
                    <DeleteUserModal
                        show={selectedItem?.id && showDeleteModal}
                        userId={selectedItem?.id}
                        handleClose={() => setShowDeleteModal(false)}
                    />
                </div>
            ) : (
                <div>No access</div>
            )}
        </div>
    );
};

export default AccountManagement;

AccountManagement.prototype = {
    usersData: Proptypes.object,
    currentUser: Proptypes.object
};

let element = null;

document.addEventListener('DOMContentLoaded', function (event) {
    if (!element) {
        element = document.getElementById('AccountManagement');
        const usersData = element?.dataset?.users && JSON.parse(element.dataset.users);
        const currentUser = element?.dataset?.user && JSON.parse(element.dataset.user);
        const root = element && createRoot(element);

        if (element) root.render(<AccountManagement usersData={usersData} currentUser={currentUser}/>);
    }
});
